(function () {
  // Every section with offer cards outputs this script tag, so the browser runs the file
  // several times per page (five on the home page). One installation is enough — each
  // extra copy registered its own listeners and equalized (and re-laid out) every row again.
  if (window.__petmall && typeof window.__petmall.scheduleEqualizeOpcCardHeights === 'function') return;

  let equalizeTimer;

  function getEqualizeRoot(card) {
    return (
      card.closest('#ProductsList') ||
      card.closest('featured-collection') ||
      card.closest('.featured-collection__items') ||
      card.closest('.products-list') ||
      card.closest('[id^="product-list-"]') ||
      card.closest('.section') ||
      document.body
    );
  }

  /*
   * Equalizes the visual box — the stack (card + the "Регулярна доставка" strip attached
   * under it), not the card alone. Measuring the card and applying its max as a min-height
   * made every subscription stack taller than the row (card max + strip), so the cards
   * without a strip were stretched and showed that difference as dead space above the
   * price. The card grows inside the stack (CSS: .opc-stack > .opc { flex: 1 1 auto }),
   * so its buy row still sits at the bottom of the box.
   */
  function equalizeOpcCardHeights() {
    const stacks = Array.from(document.querySelectorAll('.opc-stack'))
      .filter((stack) => stack.querySelector(':scope > .opc'));
    if (!stacks.length) return;

    // Reads before writes. Any DOM write before measuring makes the browser lay the page out
    // again (PageSpeed "forced reflow"), so: only a re-run (resize, filters) has min-heights to
    // clear, and rows are grouped by their root element in memory, not via a data attribute.
    const hasSetHeights = stacks.some((stack) => {
      const card = stack.querySelector(':scope > .opc');
      return stack.style.minHeight || (card && card.style.minHeight);
    });
    if (hasSetHeights) {
      stacks.forEach((stack) => {
        stack.style.minHeight = '';
        const card = stack.querySelector(':scope > .opc');
        if (card) card.style.minHeight = '';
      });
    }

    // One layout here measures the natural heights of every stack: root -> row top -> stacks.
    const roots = new Map();
    stacks.forEach((stack) => {
      const root = getEqualizeRoot(stack);
      const rect = stack.getBoundingClientRect();
      const top = Math.round(rect.top + window.scrollY);
      if (!roots.has(root)) roots.set(root, new Map());
      const rows = roots.get(root);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push({ stack, height: Math.round(rect.height) });
    });

    roots.forEach((rows) => {
      rows.forEach((row) => {
        const max = Math.max(...row.map((item) => item.height));
        row.forEach((item) => {
          item.stack.style.minHeight = `${max}px`;
        });
      });
    });
  }

  function scheduleEqualizeOpcCardHeights() {
    window.clearTimeout(equalizeTimer);
    equalizeTimer = window.setTimeout(equalizeOpcCardHeights, 50);
  }

  window.__petmall = window.__petmall || {};
  window.__petmall.equalizeOpcCardHeights = equalizeOpcCardHeights;
  window.__petmall.scheduleEqualizeOpcCardHeights = scheduleEqualizeOpcCardHeights;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEqualizeOpcCardHeights);
  } else {
    scheduleEqualizeOpcCardHeights();
  }

  window.addEventListener('load', scheduleEqualizeOpcCardHeights);
  window.addEventListener('resize', scheduleEqualizeOpcCardHeights);
  document.addEventListener('collection:rerendered', scheduleEqualizeOpcCardHeights);
  if (window.FoxTheme?.pubsub?.subscribe && window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.facetUpdate) {
    window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, scheduleEqualizeOpcCardHeights);
  }
})();

if (!customElements.get('offer-product-card')) {
  customElements.define(
    'offer-product-card',
    class OfferProductCard extends HTMLElement {
      connectedCallback() {
        this.variantInput = this.querySelector('.product-variant-id');
        this.pills = Array.from(this.querySelectorAll('.opc__variant'));
        this.priceEl = this.querySelector('[data-opc-price]');
        this.pctEl = this.querySelector('[data-opc-pct]');
        this.saveEl = this.querySelector('[data-opc-save]');
        this.image = this.querySelector('[data-opc-image]');
        this.atc = this.querySelector('.opc__atc');
        this.atcText = this.querySelector('.opc__atc-label');
        this.buyEl = this.querySelector('[data-opc-buy]');
        this.notifyBtn = this.querySelector('[data-pm-notify]');

        // Listen on the cell, not the pill: the discount band sits next to the button
        // inside the cell, and the whole block should select the variant. Clicks on the
        // pill bubble up to the same handler, so this fires once either way.
        this.pills.forEach((pill) => {
          const target = pill.closest('.opc__variant-cell') || pill;
          target.addEventListener('click', () => this.selectVariant(pill));
        });

        this._bindAddedFeedback();

        if (typeof window.__petmall.scheduleEqualizeOpcCardHeights === 'function') {
          window.requestAnimationFrame(window.__petmall.scheduleEqualizeOpcCardHeights);
        } else if (typeof window.__petmall.equalizeOpcCardHeights === 'function') {
          window.requestAnimationFrame(window.__petmall.equalizeOpcCardHeights);
        }
      }

      /**
       * Confirm the add on the button itself ("Добавено ✓") for a few seconds.
       * ProductForm (theme.js) owns the AJAX add and only announces the result on
       * document, so the card claims the next `product-ajax:added` after its own
       * submit and reverts on error or on a variant change.
       */
      _bindAddedFeedback() {
        this.form = this.querySelector('form[data-type="add-to-cart-form"]');
        if (!this.form || !this.atc || !this.atcText || !this.atc.dataset.textAdded) return;

        this._addPending = false;
        this._addedTimer = null;

        this.form.addEventListener('submit', () => {
          this._addPending = true;
        });

        document.addEventListener('product-ajax:added', () => {
          if (!this._addPending) return;
          this._addPending = false;
          this._showAdded();
        });

        document.addEventListener('product-ajax:error', () => {
          this._addPending = false;
        });
      }

      _showAdded() {
        window.clearTimeout(this._addedTimer);
        this.atc.classList.add('opc__atc--added');
        this.atcText.textContent = this.atc.dataset.textAdded + ' \u2713';
        this._addedTimer = window.setTimeout(() => this._resetAtcLabel(), 3000);
      }

      _resetAtcLabel() {
        window.clearTimeout(this._addedTimer);
        if (!this.atc || !this.atcText) return;
        this.atc.classList.remove('opc__atc--added');
        const available = this.dataset.available !== 'false';
        this.atcText.textContent = available
          ? '+ ' + (this.atc.dataset.textAdd || '')
          : this.atc.dataset.textSoldout || '';
      }

      selectVariant(pill) {
        const available = pill.dataset.available === 'true';
        // Sold-out pills stay clickable for price preview, but never get the active selected chrome.
        this.pills.forEach((p) => p.classList.toggle('is-selected', p === pill && available));

        const id = pill.dataset.variantId;

        if (this.variantInput) {
          this.variantInput.value = id;
          this.variantInput.disabled = !available;
        }

        if (this.priceEl && pill.dataset.priceHtml != null) {
          this.priceEl.innerHTML = pill.dataset.priceHtml;
        }

        if (this.pctEl) {
          const pct = pill.dataset.pctHtml || '';
          this.pctEl.innerHTML = pct;
          this.pctEl.hidden = pct.trim() === '';
        }

        if (this.saveEl) {
          const save = pill.dataset.saveHtml || '';
          this.saveEl.innerHTML = save;
          this.saveEl.hidden = save.trim() === '';
        }

        if (this.image && pill.dataset.mediaSrc) {
          this.image.src = pill.dataset.mediaSrc;
          if (pill.dataset.mediaSrcset) {
            this.image.srcset = pill.dataset.mediaSrcset;
          } else {
            this.image.removeAttribute('srcset');
          }
        }

        if (this.atc) {
          this.atc.disabled = !available;
          window.clearTimeout(this._addedTimer);
          this.atc.classList.remove('opc__atc--added');
          if (this.atcText && this.atc.dataset.textAdd) {
            this.atcText.textContent = available ? '+ ' + this.atc.dataset.textAdd : this.atc.dataset.textSoldout;
          }
        }

        // Sold-out variants show the back-in-stock trigger instead of the add button.
        if (this.notifyBtn) {
          this.notifyBtn.dataset.variantId = id;
          if (this.buyEl) this.buyEl.classList.toggle('opc__buy--notify', !available);
        }

        if (pill.dataset.price != null) {
          this.dataset.price = pill.dataset.price;
        }
        if (pill.dataset.compare != null) {
          this.dataset.compare = pill.dataset.compare;
        }
        this.dataset.available = available;

        this.dispatchEvent(
          new CustomEvent('opc:variant:change', {
            bubbles: true,
            detail: {
              variantId: id,
              available,
              price: Number(this.dataset.price || 0),
              compareAtPrice: Number(this.dataset.compare || 0),
            },
          })
        );
      }
    }
  );
}
